module.exports = __webpack_public_path__ + "img/chevron-right-20x20-gray_accentuate.3928f564.svg";